<template>
  <div>
    <banner />
    <search-bar />
    <directory-results />
    <investor-form-banner />
  </div>
</template>

<script>
import Banner from "../elements/Banner.vue";
import SearchBar from "../elements/SearchBar/SearchBar.vue";
import DirectoryResults from "../elements/directory/DirectoryResults.vue";
import InvestorFormBanner from "../elements/InvestorFormBanner.vue";

import { mapGetters, mapActions, mapMutations } from "vuex";
import slugify from "slugify";

export default {
  name: "Index",
  components: {
    banner: Banner,
    "search-bar": SearchBar,
    "directory-results": DirectoryResults,
    "investor-form-banner": InvestorFormBanner
  },
  computed: {
    ...mapGetters([
      "countrySelected",
      "sectorSelected",
      "capitalTypeSelected",
      "providerTypeSelected",
      "femaleFocusSelected",
      "providerList"
    ])
  },
  methods: {
    ...mapActions({
      fetchProvider: "fetchProvider",
      search: "search"
    }),
    ...mapMutations(["setPage", "setFirstSearch"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Index.vue